import { render, staticRenderFns } from "./ServiceTransition.vue?vue&type=template&id=97d16404&scoped=true"
import script from "./ServiceTransition.vue?vue&type=script&lang=js"
export * from "./ServiceTransition.vue?vue&type=script&lang=js"
import style0 from "./ServiceTransition.vue?vue&type=style&index=0&id=97d16404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d16404",
  null
  
)

export default component.exports